import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { post, get } from '@/utils/fetch';
import { TOKEN_KEY } from '@/utils/cookie';
import { useAuthStore } from '@/utils/authStore';
import { authToken } from '@/utils';

function useAuth({lang}) {
  const { i18n } = useTranslation();
  const [loginStatus, setLoginStatus] = useState(false);
  const setAuthToken = useAuthStore((state) => state.setAuthToken);

  const getTokenByAccessToken = async (
    accessToken: string,
    callback?: () => void
  ) => {
    const resp = (await post('/api/login', {
      fb_access_token: accessToken,
    })) as any
    localStorage.setItem(TOKEN_KEY, JSON.stringify(resp.data))
    callback?.()
  }

  // 1，先進行 token 鑒權（這個是根據上一次授權登錄拿到的assess_token來生成的）
  // 2，不應該先彈窗，應該先去判斷 facebook 登錄狀態
  // 3，沒有登錄的情況下，再去調登錄api
  const checkToken = (callback?: () => void) => {
    return new Promise((resolve) => {
      if (authToken()) {
        callback?.()
        resolve('token valid')
      } else {
        window?.FB?.getLoginStatus((response: any) => {
          if (response.status === 'connected') {
            getTokenByAccessToken(response?.authResponse?.accessToken, () => {
              callback?.() // new add
              resolve('token valid')
            })
          } else {
            window?.FB?.login((res: any) => {
              if (res?.status === 'connected') {
                getTokenByAccessToken(res?.authResponse?.accessToken, () => {
                  callback?.() // new add
                  resolve('token valid')
                })
              }
            })
          }
        })
      }
    })
  }

  const checkTokenBySDK = (
    drivers = ['google', 'apple', 'facebook'],
    callback?: () => void
  ) => {
    return new Promise((resolve) => {
      if (authToken()) {
        callback?.()
        resolve('token valid')
      } else {
        const clientInfo = {
          client_id: '7izjwitb5bxfogee',
          client_secret: 'kii1x1ay9hxan5a1cdnpavs48vrlfijc',
          drivers,
          lang: lang ?? i18n.language,
        }

        const jssdk = (window as any)?.HuanleJssdk?.getInstance(clientInfo)

        localStorage.setItem('client_info', JSON.stringify(clientInfo))

        jssdk.thirdLogin({
          success: (info) => {
            localStorage.setItem(
              TOKEN_KEY,
              JSON.stringify({
                ...info,
                expired_at: dayjs(info.expired_at).unix(),
              })
            )
            callback?.() // new add
            resolve({
              ...info,
              expired_at: dayjs(info.expired_at).unix(),
            })
            setAuthToken(info);
            console.log('登录成功')
          },
        })
      }
    })
  }

  const logOut = () => {
    localStorage.removeItem(TOKEN_KEY)
  }

  return { loginStatus, checkToken, logOut, checkTokenBySDK }
}

export default useAuth
